import { Alert, Box, Grid, IconButton, Link, Typography, styled } from "@mui/material";
import CustomIcon from "components/CustomIcon";
import Status from "components/Status";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { cleanAllProgramData, getInitialProgram } from "store/actions/program";
import { copySession, getSessions } from "store/actions/sessions";

const StyledAlert = styled(Alert)(() => ({
  cursor: "pointer",
  border: "1px solid #E0E4EA",
  padding: "12px 16px",
  ".MuiAlert-icon": {
    display: "none",
  },
  ".MuiAlert-action": {
    alignItems: "center",
  },
  ".MuiAlert-message": {
    width: "100%",
    display: "flex",
    alignItems: "center",
    color: "#4F5668",
    fontSize: "14px",
    padding: 0,
  },
}));

const SessionListBody = ({ toggleDeleteModel, session, isTemplate, isEvocoachTemplate }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { type } = useSelector((state) => state.user.userDetails);
  const fullName = (fName, lName) => {
    if (fName || lName) {
      return `${fName} ${lName}`;
    } else {
      return "-";
    }
  };
  const actionButtons = (
    <>
      <IconButton
        color="inherit"
        size="small"
        onClick={(e) => {
          e.stopPropagation();
          dispatch(cleanAllProgramData());
          dispatch(getInitialProgram());
          navigate(`/fitness/sessions/${session._id}`);
        }}
      >
        <CustomIcon
          iconSrc="/assets/logo/detail_icon.svg"
          iconHoverSrc="/assets/logo/detail_icon_hover.svg"
        />
      </IconButton>
      <IconButton
        color="inherit"
        size="small"
        onClick={(e) => {
          e.stopPropagation();
          dispatch(copySession(session._id)).then((newId) => {
            if (newId && isEvocoachTemplate) {
              navigate(`/fitness/sessions/${newId}`);
            } else {
              dispatch(getSessions());
            }
          });
        }}
      >
        <CustomIcon
          iconSrc="/assets/logo/copy.svg"
          iconHoverSrc="/assets/logo/copy_hover.svg"
        />
      </IconButton>
      {!isTemplate && (
        <IconButton
          color="info.main"
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            toggleDeleteModel(session);
          }}
        >
          <CustomIcon
            iconSrc="/assets/logo/trash_icon.svg"
            iconHoverSrc="/assets/logo/trash_icon_hover.svg"
          />
        </IconButton>
      )}
    </>
  );

  return (
    <StyledAlert
      variant="outlined"
      severity="info"
      onClick={() => {
        dispatch(cleanAllProgramData());
        dispatch(getInitialProgram());
        navigate(`/fitness/sessions/${session._id}`);
      }}
    >
      {/* Mobile card layout */}
      <Box sx={{ display: { xs: "flex", sm: "none" }, width: "100%", flexDirection: "column", gap: 0.5 }}>
        <Link
          underline="hover"
          color="#4F5668"
          sx={{ cursor: "pointer", fontWeight: 600 }}
          onClick={(e) => {
            e.stopPropagation();
            dispatch(cleanAllProgramData());
            dispatch(getInitialProgram());
            navigate(`/fitness/sessions/${session._id}`);
          }}
        >
          {session.name}
        </Link>
        <Typography fontSize="12px" color="#757E97" noWrap>
          {fullName(session.first_name, session.last_name)}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mt: 0.25 }}>
          <Status type={session.status} label={session.status} />
          <Box sx={{ display: "flex" }}>{actionButtons}</Box>
        </Box>
      </Box>

      {/* Desktop row layout */}
      <Grid container sx={{ display: { xs: "none", sm: "flex" } }}>
        <Grid
          item
          sm={4}
          sx={{ display: "flex", gap: "10px", alignItems: "center" }}
        >
          <Link
            underline="hover"
            color="#4F5668"
            sx={{ cursor: "pointer" }}
            onClick={(e) => {
              e.stopPropagation();
              dispatch(cleanAllProgramData());
              dispatch(getInitialProgram());
              navigate(`/fitness/sessions/${session._id}`);
            }}
          >
            {session.name}
          </Link>
        </Grid>
        <Grid item sm={4} sx={{ display: "flex", alignItems: "center" }}>
          <Link
            underline="hover"
            color="#4F5668"
            sx={{ cursor: "pointer" }}
            onClick={(e) => {
              e.stopPropagation();
              if (session.user_id) {
                navigate(`/clients/${session.user_id}`);
              }
            }}
          >
            {fullName(session.first_name, session.last_name)}
          </Link>
        </Grid>
        <Grid item sm={2} sx={{ display: "flex", alignItems: "center" }}>
          <Status type={session.status} label={session.status} />
        </Grid>
        <Grid item sm={2} sx={{ textAlign: "right" }}>
          {actionButtons}
        </Grid>
      </Grid>
    </StyledAlert>
  );
};

export default SessionListBody;
